import React from 'react';

function MonospaceIcon({ className }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="currentColor">
            <rect width="30" height="30" fill="none"/>
            <path d="M13.3359 9.6L15.0288 14.8L16.8573 9.6H18.5002V20H17.2145V15.85L17.3216 11.5071L15.4002 17.1071H14.6431L12.8788 11.6571L12.9859 15.85V20H11.7002V9.6H13.3359Z" />
        </svg>
    );
}

export default MonospaceIcon;
